import { useTranslation } from 'react-i18next';
import { NavLink, useLocation } from 'react-router-dom';

import { cn } from '~/lib/cn';

interface TabLinksProps {
  className?: string;
}

export function TabLinks({ className = '' }: TabLinksProps) {
  const { t } = useTranslation('marketing', {
    keyPrefix: 'anomalyDashboard',
  });

  const pathname = useLocation().pathname;

  const baseLinkClassName = cn(
    'flex items-center gap-xs !border-b-2xs pb-xs duration-300 ease-out border-transparent hover:text-default',
  );

  const selectedLinkClassName = cn('border-b-primary-default text-default');

  return (
    <div
      className={cn(
        'mb-sm flex gap-lg border-b text-body-sm font-semibold border-emphasis-subtle text-subtle',
        className,
      )}
      aria-label={t('anomalyDashboardTabs')}
    >
      <NavLink
        to="anomaly-detection"
        className={cn(baseLinkClassName, {
          [selectedLinkClassName]: pathname.endsWith(
            'catalog/anomaly-detection',
          ),
        })}
      >
        {t('tabs.anomalyDetection')}
      </NavLink>

      <NavLink
        to="key-moments"
        className={cn(baseLinkClassName, {
          [selectedLinkClassName]: pathname.endsWith('catalog/key-moments'),
        })}
      >
        {t('tabs.keyMoments')}
      </NavLink>

      <NavLink
        to="short-term-forecasting"
        className={cn(baseLinkClassName, {
          [selectedLinkClassName]: pathname.endsWith(
            'catalog/short-term-forecasting',
          ),
        })}
      >
        {t('tabs.shortTermForecasting')}
      </NavLink>
    </div>
  );
}

TabLinks.displayName = 'TabLinks';
